module.exports = __webpack_public_path__ + "static/media/conversation.f940c771.svg";